<template>
  <van-popup v-model="onShow" position="bottom" class="fetch-popup">
    <van-row align="center" class="fetch-header">
      <van-search
        v-model="value"
        @blur="onSearch"
        @clear="onReset"
        shape="round"
        :placeholder="$t.meta.search"
      />
    </van-row>

    <div class="fetch-content" v-if="items">
      <van-cell-group v-for="(item, index) in items" :key="index" @click="onClick(item)">
        <van-cell :title="item.text">
          <template #right-icon>
            <van-image
              class="image"
              v-if="item.image"
              :src="imgUrlFilter(item.image)"
            ></van-image>
          </template>
        </van-cell>
      </van-cell-group>
    </div>
  </van-popup>
</template>

<script>
import Vue from "vue";
import { Popup, Row, CellGroup, Cell, Search } from "vant";
Vue.use(Popup).use(Row).use(CellGroup).use(Cell).use(Search);

export default {
  name: "FetchList",
  props: ["type", "request", "event"],
  data() {
    return {
      value: "",
      items: [],
      onShow: false,
    };
  },
  mounted() {
    this.$bus.$off(this.event).$on(this.event, (isShow) => {
      this.onShow = isShow;
    });
  },
  methods: {
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    onSearch() {
      if (!this.value) {
        return;
      }
      this.$commonMethod.showLoading();
      var param = {
        CompanyName: this.value.toLowerCase(),
        CustomerType: 0,
        PageIndex: 1,
        PageSize: 10000,
        CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
        UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      };
      this.$api[this.type]
        [this.request](param)
        .then((res) => {
          var result = [];
          res.data.forEach((item) => {
            let data = {
              text: item.CompanyName ? item.CompanyName : "",
              value: item.CustomerId ? item.CustomerId : "",
              CustomerPhone: item.CustomerPhone ? item.CustomerPhone : "",
              CustomerNumber: item.CustomerNumber ? item.CustomerNumber : "",
              Address: item.Address ? item.Address : "",
            };
            result.push(data);
          });
          this.items = result;
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onReset() {
      this.items = [];
    },
    onClick(item) {
      this.$emit("onSelect", item);
      this.onShow = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/publicStyle.scss";
.fetch-popup {
  height: 70%;
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
  .fetch-header {
    width: auto;
    padding: 2%;
  }
  .fetch-content {
    .image {
      width: 30px;
      height: auto;
    }
  }
}
</style>
